type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function CloseMenuIcon(props: Props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: props.width ?? 24,
        height: props.height ?? 24,
      }}
      className={props.className}
    >
      <path
        d="M18 6 6 18M6 6l12 12"
        stroke={props.stroke ?? '#593B37'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
